const SuccessIcon = ({ fill = "#25AE88", ...props }) => (
    <svg
        fill={fill}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        {...props}
    >
        <g>
            <circle fill={fill} cx="25" cy="25" r="25" />
            <polyline
                fill="none"
                stroke="#FFFFFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                points="38,15 22,33 12,25"
            />
        </g>
    </svg>
);

export default SuccessIcon;
